module.exports = ".addInventoryLabel {\r\n\twidth:170px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory-manager/add-inventory/add-inventory.component.css
// module id = ./src/app/inventory-manager/add-inventory/add-inventory.component.css
// module chunks = main